import Request from './baseRequest'

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const _createSynonym = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/searches/synonyms`,
    payload,
    config
  )
}

const _updateSynonym = synonym => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/searches/synonyms/${synonym._id}`, synonym, config)
}

const _deleteSynonym = synonymId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.delete(`${window.config.VUE_APP_BACKEND}/api/searches/synonyms/${synonymId}`, config)
}

const _getSynonyms = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/searches/synonyms?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/searches/synonyms`

  return Request.get(
    url,
    config
  )
}

const _updateSearchableProperties = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/searcheable-fields`, payload.body, config)
}

const _updateFilterableProperties = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/filterable-fields`, payload.body, config)
}

const _updateStopWords = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/stopwords`, payload.body, config)
}

const _updateTypoTolerance = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/typo-tolerance`, payload.body, config)
}

const _updateFacets = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/facets`, payload.body, config)
}

const _updateFacetOptions = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/facet-options`, payload.body, config)
}

const _updateFacetValueOrder = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/facet-value-order`, payload.body, config)
}

const _getFacetValues = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    },
    params: { field: payload.field }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/facet-values`, config)
}

const _getConfigurations = projectId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/searches/application/${projectId}/configuration`, config)
}

const _updateRankingRules = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/ranking-rules`, payload.body, config)
}

const _updateRankingOptions = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/ranking-options`, payload.body, config)
}

const _updateRankBoostRules = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/rank-boost-rules`, payload.body, config)
}

const _updateReRanking = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/re-ranking`, payload.body, config)
}

const _updateMinInstaLength = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/min-insta-length`, payload.body, config)
}

const _updateInternalIps = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/internal-ips`, payload.body, config)
}

const _getClientIp = () => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/searches/client-ip`, config)
}

const _updateHasSkuSearchByList = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/has-sku-search-by-list`, payload.body, config)
}

const _updateRules = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/rules`, payload.body, config)
}

const _updatePostFilterConfig = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/post-filter-config`, payload.body, config)
}

const _updateSearchInstructions = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/search-instructions`, payload.body, config)
}

const _updateAdditionalAttributes = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/additional-attributes`, payload.body, config)
}

const _updateQueryRewriteRulesProduct = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/query_rewrite_rules_product`, payload.body, config)
}

const _updateQueryRewriteRulesOcasion = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/query_rewrite_rules_ocasion`, payload.body, config)
}

const _updateExtendedFields = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/extended_fields`, payload.body, config)
}

const _updateKeywordInstructions = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/keyword_instructions`, payload.body, config)
}

const _updateImageSearchInstructions = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/image_search_instructions`, payload.body, config)
}

const _updateNextSearchBlockedTerms = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/next-search-blocked-terms`, payload.body, config)
}

const _updateBoosting = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/boosting`, payload.body, config)
}

const _updateAutoFilterExcludedFacets = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/auto-filter-excluded-facets`, payload.body, config)
}

const _updateRetrievalWeights = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/retrieval-weights`, payload.body, config)
}

const _updateMatchingRules = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/matching-rules`, payload.body, config)
}

const _updateQueryRewriteAdvanced = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/query-rewrite-advanced`, payload.body, config)
}

const _updateRerankerFields = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/reranker-fields`, payload.body, config)
}

const _updateFilterRules = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/filter-rules`, payload.body, config)
}

const _regenerateImageKeywords = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/regenerate-image-keywords`, {}, config)
}

const _updateLookSearch = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/look-search`, payload.body, config)
}

// Ajustes del buscador que hasta ahora solo se editaban por API (ver admin-apis):
// flags de query_rewrite_config, unificación de valores, perfil de la tienda, activación
// y lo que el buscador calcula solo (insights + estado del entrenamiento).
const _authConfig = () => ({ headers: { authorization: `Bearer ${getUserToken()}` } })

const _updateSearchFlags = payload =>
  Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/search-flags`, payload.body, _authConfig())

const _updateValueNormalization = payload =>
  Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/value-normalization`, payload.body, _authConfig())

const _updateProductEnrichment = payload =>
  Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/product-enrichment`, payload.body, _authConfig())

const _updateEnableSearch = payload =>
  Request.post(`${window.config.VUE_APP_BACKEND}/api/searches/application/${payload.projectId}/enable-search`, payload.body, _authConfig())

const _getSearchInsights = projectId =>
  Request.get(`${window.config.VUE_APP_BACKEND}/api/searches/application/${projectId}/search-insights`, _authConfig())

export default {
  createSynonym: _createSynonym,
  updateSynonym: _updateSynonym,
  deleteSynonym: _deleteSynonym,
  getSynonyms: _getSynonyms,

  updateSearchableProperties: _updateSearchableProperties,
  updateFilterableProperties: _updateFilterableProperties,
  updateStopWords: _updateStopWords,
  updateTypoTolerance: _updateTypoTolerance,
  updateFacets: _updateFacets,
  updateFacetOptions: _updateFacetOptions,
  updateFacetValueOrder: _updateFacetValueOrder,
  getFacetValues: _getFacetValues,
  getConfigurations: _getConfigurations,
  updateRankingRules: _updateRankingRules,
  updateRankingOptions: _updateRankingOptions,
  updateRankBoostRules: _updateRankBoostRules,
  updateReRanking: _updateReRanking,
  updateMinInstaLength: _updateMinInstaLength,
  updateHasSkuSearchByList: _updateHasSkuSearchByList,
  updateInternalIps: _updateInternalIps,
  getClientIp: _getClientIp,
  updateRules: _updateRules,
  updatePostFilterConfig: _updatePostFilterConfig,
  updateSearchInstructions: _updateSearchInstructions,
  updateAdditionalAttributes: _updateAdditionalAttributes,
  updateQueryRewriteRulesProduct: _updateQueryRewriteRulesProduct,
  updateQueryRewriteRulesOcasion: _updateQueryRewriteRulesOcasion,
  updateExtendedFields: _updateExtendedFields,
  updateKeywordInstructions: _updateKeywordInstructions,
  updateImageSearchInstructions: _updateImageSearchInstructions,
  updateNextSearchBlockedTerms: _updateNextSearchBlockedTerms,
  updateBoosting: _updateBoosting,
  updateAutoFilterExcludedFacets: _updateAutoFilterExcludedFacets,
  updateRetrievalWeights: _updateRetrievalWeights,
  updateMatchingRules: _updateMatchingRules,
  updateQueryRewriteAdvanced: _updateQueryRewriteAdvanced,
  updateRerankerFields: _updateRerankerFields,
  updateFilterRules: _updateFilterRules,
  regenerateImageKeywords: _regenerateImageKeywords,
  updateLookSearch: _updateLookSearch,
  updateSearchFlags: _updateSearchFlags,
  updateValueNormalization: _updateValueNormalization,
  updateProductEnrichment: _updateProductEnrichment,
  updateEnableSearch: _updateEnableSearch,
  getSearchInsights: _getSearchInsights
}
